import styled from "styled-components";
import { HXSectionTitle, HXSectionCard, Text } from "./HXDesktopPage.styles";
import { FlexColumnDiv } from "./common.styles";
export const NoDataParent = styled.div `
    align-self: stretch;
    padding: ${(props) => (props.addPadding ? "24px 0px" : "0")};
    margin: ${(props) => { var _a; return (_a = props.margin) !== null && _a !== void 0 ? _a : 0; }};
`;
export const NoDataContainer = styled(HXSectionCard) `
    padding: 24px 80px;
    justify-content: center;
    align-items: center;
    gap: 24px;
`;
export const NoDataTextContainer = styled(FlexColumnDiv) `
    justify-content: center;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;
export const NoDataTitle = styled(HXSectionTitle) `
    text-align: center;
`;
export const NoDataText = styled(Text) `
    align-self: stretch;
    text-align: center;
    white-space: pre-wrap;
`;
export const NoDataImage = styled.img `
    width: 280px;
`;
